/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Center" |
*
* @param {Position_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_title = /** @type {((inputs?: Position_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : Au Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: Centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：中路")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ポジション: センター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थान: केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Centro")
	return /** @type {LocalizedString} */ ("Position: Center")
});